module.exports = __webpack_public_path__ + "static/media/slider-8.060798fd.jpg";